import React from 'react';
import { IQuery, IQueryBuilderContext, IRegisteredStep, StepConfiguratorProps } from "@types";
import { getRegisteredStepByType, getSelectedStepDetailsById } from '@utils';
import { FormSection } from '@components/FormSection/FormSection';
import { hasValue, Input } from 'uxp/components';
import { updateStep } from './StepConfigUtils';
import classNames from 'classnames';
import './StepConfigurator.scss';

const StepRenderer: React.FC<{ step: IRegisteredStep, query: IQuery, context: IQueryBuilderContext, onChange: (query: IQuery) => void, id: string }> = (props) => {
    return <>{props.step?.render(props.context, props.query, props.onChange, props.id)}</>;
}
export const StepConfigurator: React.FC<StepConfiguratorProps> = (props) => {

    const { query, onChange, selectedStepId, context } = props
    const { step } = getSelectedStepDetailsById(query, selectedStepId)

    function updateName(name: string) {
        const _query = updateStep(query, selectedStepId, 'name', name)
        onChange(_query)
    }

    function renderNameField() {
        return <FormSection
            label='Name'
            error={!hasValue(step?.name) ? 'Name is required' : null}
        >
            <Input value={step?.name || ''} onChange={s => updateName(s)} />
        </FormSection>
    }

    const registeredStep = getRegisteredStepByType(step?.type)
    function renderStep() {
        if (!registeredStep) return null
        return <StepRenderer key={registeredStep.type} step={registeredStep} context={context} query={query} onChange={onChange} id={selectedStepId} />;
    }

    if (!registeredStep) return null
    return <div className='lucy-query-engine-step-configurator-container'>
        <div className="lucy-query-engine-step-configurator-header">
            <div className={classNames("query-editor-step-type-ico-container")}>
                <div className="step-icon-contianer" style={{ ...registeredStep?.iconStyles, backgroundImage: `url(${registeredStep.icon})` }} ></div>
            </div>
            {registeredStep?.name || 'Unknown Step'}
        </div>
        <div className="lucy-query-engine-step-configurator-description">{registeredStep?.description || ''}</div>
        {renderNameField()}
        {renderStep()}
    </div>;
};
